/* VH Upgrade to Elite (sections/vh-upgrade.liquid). PRESENTATION ONLY: no cart, customer or network calls.
   Builds "Your box, filled" and "Exactly what's added" from the product descriptions the section prints into data attributes,
   with the same parser as assets/vh-account.js itemsOf(). Plays the approved entrance (one-shot, GSAP when it loads). */
(function () {
  var root = document.getElementById('vh-upgrade');
  if (!root) return;
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var fmt = function (s, o) { return s.replace(/\{(\w+)\}/g, function (m, k) { return o[k]; }); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]; }); };

  /* same parser as assets/vh-account.js itemsOf(): "(2) V-LOVKAFE, (3) V-ITADOL ... Total Products: 99" */
  var itemsOf = function (txt) {
    txt = String(txt || '');
    var tot = txt.match(/(?:Total Products|Quantity of Products)\s*:\s*(\d+)/i);
    var list = {}, sum = 0, m, body = txt.split(/Total Products|Quantity of Products|Individual Products|FDA Disclaimer|Disclaimer:/i)[0];
    var start = body.search(/\(\d+\)/);
    if (start >= 0) {
      var re = /\((\d+)\)\s*([^,(]+?)\s*(?=,|\(|$)/g, seg = body.slice(start);
      while ((m = re.exec(seg))) { var n = m[2].replace(/\s+$/, '').trim(); if (n) { list[n] = (list[n] || 0) + (+m[1]); sum += +m[1]; } }
    }
    return {total: tot ? +tot[1] : sum, list: list};
  };

  var thumbs = {};
  try { thumbs = JSON.parse(($('#vuThumbs') || {}).textContent || '{}'); } catch (e) {}
  /* names in pack descriptions vary ("SMART BIOTICS" / "SMARTBIOTICS"): match ignoring spaces, hyphens and case */
  var vhKey = function (s) { return String(s).toUpperCase().replace(/[^A-Z0-9+]/g, ''); };
  Object.keys(thumbs).forEach(function (k) { var nk = vhKey(k); if (!thumbs[nk]) thumbs[nk] = thumbs[k]; });
  var nameOf = function (l) { return thumbs[vhKey(l)] ? thumbs[vhKey(l)][0] : l; };
  var imgOf = function (l) { return thumbs[vhKey(l)] ? thumbs[vhKey(l)][1] : null; };
  var setN = function (k, v) { $$('[data-vu-n="' + k + '"]').forEach(function (el) { el.textContent = v; }); };

  /* ---------- what's added: the upgrade product's own contents, biggest first ---------- */
  var addsEl = $('#vuAdds'), up = addsEl ? itemsOf(addsEl.getAttribute('data-desc')) : {total: 0, list: {}};
  var list = Object.keys(up.list).map(function (k) { return [k, up.list[k]]; }).sort(function (a, b) { return b[1] - a[1]; });
  if (addsEl && list.length) {
    addsEl.innerHTML = list.map(function (e) {
      var im = imgOf(e[0]);
      return '<div class="vu-add"><span class="vu-q">×' + e[1] + '</span><span class="vu-ph">' + (im ? '<img src="' + esc(im) + '" alt="" loading="lazy">' : '<em>' + esc(nameOf(e[0])) + '</em>') + '</span><b>' + esc(nameOf(e[0]).toUpperCase()) + '</b></div>';
    }).join('');
    var h = $('[data-vu-addh]'); if (h) h.textContent = fmt(root.dataset.i18nProductsItems || '{n} products, {total} items.', {n: list.length, total: up.total});
    var a = $('[data-vu-added]'); if (a) { a.textContent = fmt(root.dataset.i18nAdded || '+{total} products', {total: up.total}); a.hidden = false; }
    setN('added', '+' + up.total);
  }

  /* ---------- your box, filled: every Elite slot, the customer's own pack items marked as already owned ---------- */
  var fill = $('#vuFill');
  if (fill) {
    var elite = itemsOf(fill.getAttribute('data-elite')), own = itemsOf(fill.getAttribute('data-own'));
    var eliteL = Object.keys(elite.list);
    if (eliteL.length && own.total) {
      var slot = function (l, cls) { var im = imgOf(l); return '<span class="vu-slot ' + cls + '" title="' + esc(nameOf(l)) + '">' + (im ? '<img src="' + esc(im) + '" alt="" loading="lazy">' : '<em>' + esc(l.slice(0, 5)) + '</em>') + '</span>'; };
      var ownS = [], newL = [];
      eliteL.forEach(function (l) {
        var q = elite.list[l], o = Math.min(q, own.list[l] || 0);
        for (var i = 0; i < o; i++) ownS.push(slot(l, 'vu-own'));
        if (q - o > 0) newL.push([l, q - o]);
      });
      newL.sort(function (a, b) { return b[1] - a[1]; });
      var newS = [];
      newL.forEach(function (e) { for (var i = 0; i < e[1]; i++) newS.push(slot(e[0], 'vu-new')); });
      var slots = $('#vuSlots');
      slots.innerHTML = ownS.join('') + newS.join('');
      slots.setAttribute('aria-label', fmt(root.dataset.i18nSlotsLabel || '{own} products you have and {added} the upgrade adds, {total} in total', {own: ownS.length, added: newS.length, total: ownS.length + newS.length}));
      setN('own', own.total); setN('elite', elite.total);
      if (!up.total) setN('added', '+' + newS.length);
      fill.hidden = false;
      $$('[data-vu-row]').forEach(function (el) { el.hidden = false; });
    }
  }

  /* ---------- entrance (approved preview motion; complete at rest without GSAP / with reduced motion) ---------- */
  if (!window.VHK) return;
  VHK.withGsap(function (ok) {
    if (!ok) return;
    var st = $('.vu-st');
    if (st) { gsap.from($$('.vu-st > *'), {autoAlpha: 0, y: 30, duration: .9, stagger: .1, ease: 'power3.out'}); return; }
    var arc = $('#vuArc');
    if (!arc) return;
    var L = arc.getTotalLength();
    gsap.timeline({delay: .15})
      .from($$('.vu-copy > *'), {autoAlpha: 0, y: 30, duration: .8, stagger: .08, ease: 'power3.out'})
      .from($$('.vu-jr .vu-from'), {autoAlpha: 0, y: 30, duration: .6, ease: 'power3.out'}, .2)
      .fromTo(arc, {strokeDashoffset: L, strokeDasharray: L + ' ' + L}, {strokeDashoffset: 0, duration: .9, ease: 'power2.inOut', onComplete: function () { arc.style.strokeDasharray = '6 8'; }}, .5)
      .from($$('.vu-jr .vu-to'), {y: -160, autoAlpha: 0, duration: 1, ease: 'bounce.out'}, 1)
      .from($$('.vu-pc'), {autoAlpha: 0, y: 30, duration: .8, ease: 'power3.out'}, .9);
    /* the new slots light up in order as the grid scrolls in (opacity only, so rows stay straight) */
    var news = $$('#vuSlots .vu-slot.vu-new');
    if (news.length) {
      gsap.set(news, {opacity: .12});
      ScrollTrigger.create({trigger: '#vuSlots', start: 'top 75%', once: true, onEnter: function () { gsap.to(news, {opacity: 1, duration: .25, stagger: {each: .018}, ease: 'none'}); }});
    }
    (window.VHK && VHK.refresh ? VHK.refresh() : ScrollTrigger.refresh());
  });
})();
